import { Component, OnInit, ViewChild, EventEmitter, Inject } from '@angular/core';
import { IPageComponent } from '~Interfaces/ipagecomponent';

import { FacturationService } from '~Services/facturation.service';

import { RechercheFacturationComponent } from '~Components/recherche-facturation/recherche-facturation.component';
import { FacturesComponent } from '~Components/factures/factures.component';
import { PaginationComponent, PageEvent } from '~Components/pagination/pagination.component';

import { Converters } from '~Tools/Converters';

/**
 * Composant de facturation
 * @extends IPageComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-facturation',
  templateUrl: './facturation.component.html',
  styleUrls: ['./facturation.component.scss']
})
export class FacturationComponent extends IPageComponent implements OnInit {

    @ViewChild('recherche', { static: false }) composantRecherche: RechercheFacturationComponent;
    @ViewChild('factures', { static: false }) composantFactures: FacturesComponent;
    @ViewChild('pagination', { static: false }) composantPagination: PaginationComponent;

    public listeFactures: any[] = [];
    public total: 0;
    public indexPage: number = 0;
    public taillePage: number = 5;

    public afficherPagination: boolean = false;

    private codesFournisseur: string[] = [];
    private dateDebut: Date = null;
    private dateFin: Date = null;

    /**
     * Constructeur
     * @param facturationService
     */
    constructor(@Inject(FacturationService) private facturationService: FacturationService) { super() }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Ev�nement lors du changement de page
     * @param e
     */
    public changementPageEvent(e: PageEvent) {
        this.listeFactures = [];

        this.indexPage = e.indexPage;
        this.taillePage = e.taillePage;

        this.lancerRecherche(e.indexPage, e.taillePage);
    }

    /**
     * Lancer la recherche
     * @param indexPage Index de la page
     * @param taillePage Taille de la page
     */
    public lancerRecherche(indexPage: number, taillePage: number) {
        if (this.codesFournisseur && this.codesFournisseur.length > 0) {
            let tris = this.ObtenirTris(this.composantFactures ? this.composantFactures.filtresTri : []);
            this.facturationService.paginerFactures(indexPage, taillePage, this.codesFournisseur, this.dateDebut, this.dateFin, tris).subscribe(retour => {
                if (retour && retour.Result) {
                    this.listeFactures = retour.Result.Resultats;
                    this.total = retour.Result.Total;
                }
            });
        }
    }

    /**
     * Rechercher
     */
    public rechercher() {
        this.lancerRecherche(this.indexPage, this.taillePage);
    }

    /**
     * Ev�nement de recherche
     * @param criteres
     */
    public rechercheEvent(criteres: any) {
        this.dateDebut = criteres.DateDebut;
        this.dateFin = criteres.DateFin;
        this.codesFournisseur = criteres.CodeFournisseurs;

        if (!this.afficherPagination) {
            this.afficherPagination = true;
            return;
        }

        this.indexPage = 0;
        this.listeFactures = [];
        this.lancerRecherche(this.indexPage, this.taillePage);
    }

    /**
     * Obtenir les tris
     * @param tris
     */
    private ObtenirTris(tris: any[]): any[] {
        let liste: any[] = [];
        for (let key in tris) {
            let val = tris[key];
            liste.push({
                Champ: key,
                Direction: val
            });
        }
        return liste;
    }
}
